import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'

  import { useRoute } from 'vue-router/composables'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'
  import useIcons from '@/composables/useIcons'
  import useEditor from '@/composables/useEditor'

  import { CourseModule } from '@/store/modules/course'

  import type { CourseItem, FollowUp } from '@/services/interfaces/Course'

  import { DateTime } from 'luxon'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FollowupTable',
  setup(__props) {

  const { vectorArrow } = useIcons()
  const route = useRoute()
  const { deleteFollowup } = useEditor(route)
  const { formatDate } = useCommonMixin()
  const { fetchCourses, openLessonModal, course, courseBundles } = useCourse()
  const { translateString } = useI18n()

  const followups = computed(() => CourseModule.companyFollowups)

  const columns = [
    {
      title: translateString('editor.followup.columns.lesson'),
      sort: false,
    },
    {
      title: translateString('editor.followup.columns.date'),
      sort: true,
    },
    {
      title: translateString('editor.followup.columns.comment'),
      sort: false,
    },
    {
      title: translateString('editor.followup.columns.delete') + '?',
      sort: false,
    },
  ]

  const loadingFollowUps = computed(() => followups.value === null)

  const showLessonModal = async (followup: FollowUp) => {
    const accessibleCourses: CourseItem[] = []

    followup.moduleCourses.forEach((course) => {
      const _course = courseBundles.value?.flatMap((bundle) => bundle.courses).find((c) => c.id === course.courseId)

      if (_course?.visibleToGroup) {
        accessibleCourses.push(_course)
      }
    })

    // we select any of the accessible courses
    const courseId = accessibleCourses[Math.floor(Math.random() * accessibleCourses.length)].id
    const moduleId = followup.moduleCourses.find((c) => c.courseId === courseId)?.moduleId

    if (courseId && moduleId) {
      if (course.value?.id !== courseId) {
        await CourseModule.getCourse({ courseId: courseId })
      }

      openLessonModal({
        lessonId: followup.lesson.id,
        courseId: courseId,
        moduleId: moduleId!,
      })
    }
  }

  const sortDirection = ref(false)
  const sortFollowups = () => {
    sortDirection.value = !sortDirection.value

    CourseModule.companyFollowups?.sort((a, b) => {
      const dateA = DateTime.fromISO(a.date)
      const dateB = DateTime.fromISO(b.date)
      if (dateA < dateB) return -1
      if (dateA > dateB) return 1
      return 0
    })

    if (sortDirection.value) CourseModule.companyFollowups?.reverse()
  }

  CourseModule.getFollowups().then((followups) => {
    if (followups) {
      if (!CourseModule.courses) {
        fetchCourses()
      }
    }
  })

return { __sfc: true,vectorArrow, route, deleteFollowup, formatDate, fetchCourses, openLessonModal, course, courseBundles, translateString, followups, columns, loadingFollowUps, showLessonModal, sortDirection, sortFollowups, computed, ref, LoadingSpinner, SVGRenderer, HTMLRenderer, useRoute, useCommonMixin, useCourse, useI18n, useIcons, useEditor, CourseModule, DateTime }
}

})